import { render, staticRenderFns } from "./Visualizar-Cliente.vue?vue&type=template&id=41b5bf0e&scoped=true&"
import script from "./Visualizar-Cliente.vue?vue&type=script&lang=js&"
export * from "./Visualizar-Cliente.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar-Cliente.vue?vue&type=style&index=0&id=41b5bf0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b5bf0e",
  null
  
)

export default component.exports